precision highp float;

vec4 galaxy(sampler2D noise, sampler2D atmosphere, sampler2D stars, float time, vec2 resolution, float dpr) {
    vec2 fragCoord = gl_FragCoord.xy * dpr;
    vec2 uv = vec2(fragCoord.x / 2000., fragCoord.y / 2000.);
    float speed = time;
    vec4 base1 = texture2D( noise, uv * .8 + cos(speed) );
    vec4 base2 = texture2D( noise, uv * 1.1 - sin(speed) );
    vec4 baseNoise = base1 * base2;
    baseNoise *= baseNoise;// * baseNoise;

    float distanceFromCenter = sqrt(uv.x * uv.x + uv.y * uv.y);
    float sinArg = ( distanceFromCenter * 8.0 ) + sin( speed * 1.5 );
    float slope = cos(sinArg);
    // vec4 baseColor = texture2D( atmosphere, uv.xy);
    vec4 baseColor = texture2D( atmosphere , (uv.xy - time * 0.15) + normalize((uv.xy)) * slope  * 0.05);
    vec4 star = texture2D(stars,
      vec2(
        (fragCoord.x - sin(time) * slope * 0.40) / 800.,
        (fragCoord.y + cos(time) * slope * 0.40) / 800.
      )
    );
    (uv.xy - speed * 0.2) + normalize((uv.xy)) * slope;

    star *= baseNoise.r;
    baseColor.rgb += star.rgb;

    vec4 final = baseColor * baseNoise.r;
    final.a = 1.;
    return final;
}

uniform sampler2D uNoise;
uniform sampler2D uAtmosphere;
uniform sampler2D uStar;
uniform float uTime;
uniform float uDpr;
uniform vec2 uResolution;
uniform vec3 uColor;
uniform float uFade;

void main() {
  gl_FragColor = mix(vec4(uColor, uFade), galaxy(uNoise, uAtmosphere, uStar, uTime, uResolution, uDpr), uFade);

}
